import React, { Component } from "react";
import { getUrlParams, handleUnauthorized } from "../utils";
import { Mutation } from "react-apollo";
import gql from "graphql-tag";
import { Link as LinkTo } from "react-router-dom";

const PASSWORD_RESET_MUTATION = gql`
  mutation PasswordChangeRequest($token: String!, $password: String!) {
    resetPassword(token: $token, password: $password) {
      id
    }
  }
`;

class ResetPassword extends Component {
  state = {
    password: "",
    token: getUrlParams()["token"] || localStorage.getItem('auth-token'),
    showLoginLink: false,
    message: "",
  };

  checkUnauthorized(error) {
    handleUnauthorized(error, this.props.history)
  }

  render() {
    const { token, password } = this.state;
    return (
      <Mutation
        mutation={PASSWORD_RESET_MUTATION}
        variables={{ token, password }}
        onError={(err) => {
          this.checkUnauthorized(err)
          if (err.graphQLErrors && err.graphQLErrors.length) {
            this.setState({
              message: err.graphQLErrors[0],
            });
          } else {
            this.setState({
              message: "An error occured when resetting the password.",
            });
          }
        }}
        onCompleted={(data) => {
          this.setState({
            message: `Password updated. ${getUrlParams()["token"] ? "Lets login!" : ""}`,
            showLoginLink: true,
          });
        }}
      >
        {(mutation) => (
          <div>
            <h4 className="mv3">{`${getUrlParams()["token"] ? "Reset password" : "Change password"}`}</h4>
            <div className="flex flex-column">
              <input
                value={password}
                onChange={(e) =>
                  this.setState({ password: e.target.value, message: "" })
                }
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    mutation();
                  }
                }}
                type="password"
                placeholder="Choose a safe password"
              />
            </div>

            {!!this.state.message.length && (
              <div className="pt2 pl1">{this.state.message}</div>
            )}
            <div className="flex mt2">
              <button
                type="submit"
                className="pointer mr2 button"
                onClick={mutation}
              >
                Update password
              </button>
              {(this.state.showLoginLink && getUrlParams()["token"]) && (

                <LinkTo to="login">
                  <button className="pointer button no-underline">login</button>
                </LinkTo>
              )}
            </div>
          </div>
        )}
      </Mutation>
    );
  }
}

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/components/ResetPassword.js